import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VerifiedUserIcon(props: IconProps) {
    return <Icon {...props} iconKey={"verified_user"}/>
}
